import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IMToolService } from '../../services/im-tool.service';
import * as constants from 'src/app/config/app-constants';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertWizardComponent } from '../alert-wizard/alert-wizard.component';
import { AddGcnDrugs, AdjustGcnDrug, GcnDrugs, GroupBy } from '../../models/gcn-drugs';

@Component({
    selector: 'app-import-wizard-duplicate-ndc',
    templateUrl: './import-wizard-duplicate-ndc.component.html',
    styleUrls: ['./import-wizard-duplicate-ndc.component.scss'],
    standalone: false
})
export class ImportWizardDuplicateNdc implements OnInit {

  @Output() hideSide = new EventEmitter<number>();
  @Output() closeWizard = new EventEmitter<boolean>();

  @Input() customerId:string;
  @Input() customerName:string;
  @Input() deviceId:number;
  dataSource = new MatTableDataSource<GcnDrugs>([]);
  gcnNumberList: GroupBy[] = [];
  isColorChange: boolean = false;
  gcnDrugList: GcnDrugs[] = [];
  gcnDrugdModel: AdjustGcnDrug;
  saveGcnDrugListModel: AddGcnDrugs[] = [];
  selectedGcnDrugList: GcnDrugs[] = [];
    // File Upload Information form
    isButtonSelectLargeBottle:boolean = false;
    isLowestUsageDrugSelect:boolean = false;
    isHighestUsageDrugSelect = false;
    isUnselectAll = false;

    displayedColumns: string[] = [
      "checkbox",
      "sl",
      "drugName",
      "gcnNumber",
      "ndc",
      "packageSize",
      "manufacturer",
      "strength",
      "unitOfUsage",
      "rxQty",
    ];
  
//#endregion

  selectedRow:any;
 

  constructor(
    private imtoolService: IMToolService,
    private ngxLoader: NgxUiLoaderService,
    public dialog: MatDialog,
    private route: Router,
    private toastService: ToastService
  ) {
    }

 ngOnInit(): void {
  if (this.deviceId === 6) {
    this.getGcnDrugListForCaps();
  } else {
    this.getGcnDrugList();
  }
}
 

  random_bg_color(): string {
    if (this.isColorChange) {
      this.isColorChange = false;
      return "rgb(191, 191, 191)";
    }
    else {
      this.isColorChange = true;
      return "rgb(255, 255, 255)";
    }
  }



  customExcelFileDownload() {
    const uri = 'data:application/vnd.ms-excel;base64,';
    let tableRow = 2;
    let tableData = this.dataSource.data.map(x=>
      {
        let styleID;
        if (x.backgroundColor === 'rgb(191, 191, 191)') {
            styleID = "S522";
        } else {
            styleID = "S52";
        }
      return `<Row ss:Index="${tableRow++}">
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.sl}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.customerDrugName == null? '': x.customerDrugName}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.gcnNumber == null? '': x.gcnNumber}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.ndc == null? '': x.ndc}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.packageSize == null? '': x.packageSize}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.manufacturer == null? '': x.manufacturer}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.strength == null? '': x.strength}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.unitOfUsage == null? '':x.unitOfUsage}</Data>
      </Cell>
      <Cell ss:StyleID="${styleID}"><Data ss:Type="String">${x.rxQty == null?'': x.rxQty}</Data>
      </Cell>
     </Row>`
      })
      let concatenatedTableData = tableData.join('');


    const template = `
    <?xml version="1.0" encoding="utf-8"?><?mso-application progid="Excel.Sheet"?><Workbook xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:x2="urn:schemas-microsoft-com:office:excel2" xmlns:html="http://www.w3.org/TR/REC-html40" xmlns:dt="uuid:C2F41010-65B3-11d1-A29F-00AA00C14882">
    <x:ExcelWorkbook>
     <x:ActiveSheet>0</x:ActiveSheet>
    </x:ExcelWorkbook>
    <o:DocumentProperties>
     <o:Created>2023-09-13T17:41:39Z</o:Created>
     <o:LastSaved>2024-01-10T10:59:44Z</o:LastSaved>
    </o:DocumentProperties>
    <o:CustomDocumentProperties>
     <o:ContentTypeId>0x010100698360ABD404FE40AAB1A4EEE7594A12</o:ContentTypeId>
     <o:MediaServiceImageTags />
     <o:_ExtendedDescription />
    </o:CustomDocumentProperties>
    <Styles>
     <Style ss:ID="Default" ss:Name="Normal">
      <ss:Alignment ss:Vertical="Bottom" />
      <ss:Font ss:Color="#000000" ss:FontName="Calibri" ss:Size="12" />
     </Style>
 
     <Style ss:ID="S50">
      <ss:Alignment ss:Vertical="Bottom" ss:WrapText="1" />
      <ss:Font ss:Bold="1" ss:FontName="Times New Roman" ss:Size="36" />
     </Style>
     <Style ss:ID="S51">
      <ss:Alignment ss:Vertical="Bottom" />
      <ss:Font ss:Color="#000000" ss:FontName="Arial" ss:Size="12" />
     </Style>
     <Style ss:ID="S52">
      <ss:Alignment ss:Vertical="Bottom" />
      <ss:Font ss:FontName="Arial"  ss:Size="12" />
     </Style>
     <Style ss:ID="S522">
      <ss:Alignment ss:Vertical="Bottom" />
      <ss:Font ss:FontName="Arial"  ss:Size="12" />
      <Interior ss:Color="#BFBFBF" ss:Pattern="Solid"/>'
     </Style>
     <Style ss:ID="S53">
      <ss:Alignment ss:Vertical="Bottom" ss:WrapText="1" />
      <ss:Font ss:FontName="Arial" ss:Size="12" />
     </Style>
     <Style ss:ID="S54">
      <ss:Alignment ss:Vertical="Bottom" />
      <ss:Font ss:FontName="Arial" ss:Background = "#FFD733" ss:Bold="1" ss:Size="12" />
     </Style>
    </Styles>
    <Worksheet ss:Name="Duplicate NDC">
     <ss:Names />
     <ss:Table ss:DefaultRowHeight="34.35" ss:DefaultColumnWidth="54" ss:ExpandedRowCount="${this.dataSource.data.length+1}" ss:ExpandedColumnCount="9">
      <Column ss:Index="1" ss:StyleID="S51" ss:AutoFitWidth="0" ss:Width="62.25" />
      <Column ss:Index="2" ss:StyleID="S51" ss:AutoFitWidth="0" ss:Width="210.75" />
      <Column ss:Index="3" ss:StyleID="S51" ss:AutoFitWidth="0" ss:Width="107.25" />
      <Column ss:Index="4" ss:StyleID="S51" ss:AutoFitWidth="0" ss:Width="59.25" />
      <Column ss:Index="5" ss:StyleID="S51" ss:AutoFitWidth="0" ss:Width="59.25" />
      <Column ss:Index="6" ss:StyleID="S51" ss:AutoFitWidth="0" ss:Width="107.25" />
      <Column ss:Index="7" ss:StyleID="S51" ss:AutoFitWidth="0" ss:Width="71.25" />
      <Column ss:Index="8" ss:StyleID="S51" ss:AutoFitWidth="0" ss:Width="89.25" />
      <Column ss:Index="9" ss:StyleID="S51" ss:AutoFitWidth="0" ss:Width="59.25" />
      <Row ss:Index="1">
       <Cell ss:StyleID="S54"><Data ss:Type="String">SL</Data>
       </Cell>
       <Cell ss:StyleID="S54"><Data ss:Type="String">Drug Name</Data>
       </Cell>
       <Cell ss:StyleID="S54"><Data ss:Type="String">GCN</Data>
       </Cell>
       <Cell ss:StyleID="S54"><Data ss:Type="String">NDC</Data>
       </Cell>
       <Cell ss:StyleID="S54"><Data ss:Type="String">Pack Qty</Data>
       </Cell>
       <Cell ss:StyleID="S54"><Data ss:Type="String">Manufacturer</Data>
       </Cell>
       <Cell ss:StyleID="S54"><Data ss:Type="String">Strength</Data>
       </Cell>
       <Cell ss:StyleID="S54"><Data ss:Type="String">Unit Usage</Data>
       </Cell>
      <Cell ss:StyleID="S54"><Data ss:Type="String">Rx Qty</Data>
       </Cell>
      </Row>

      ${concatenatedTableData}
 
     </ss:Table>
     <WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel">
      <PageSetup>
       <Header x:Margin="0.3" />
       <Footer x:Margin="0.3" />
       <PageMargins x:Top="0.75" x:Bottom="0.75" x:Left="0.7" x:Right="0.7" />
      </PageSetup>
      <Print>
       <PaperSizeIndex>9</PaperSizeIndex>
       <HorizontalResolution>600</HorizontalResolution>
       <VerticalResolution>600</VerticalResolution>
      </Print>
      <Panes>
       <Pane>
        <Number>3</Number>
        <ActiveRow>3</ActiveRow>
        <ActiveCol>7</ActiveCol>
        <RangeSelection>R4C8</RangeSelection>
       </Pane>
      </Panes>
     </WorksheetOptions>
    </Worksheet>
   </Workbook>
   `
    const base64 = function(s:any) { return window.btoa(unescape(encodeURIComponent(s))) };
    const link = document.createElement('a');
    link.download =`Duplicate_NDC_${this.customerName}.xls`;
    link.href = uri + base64(template);
    link.click();
}
  openAlertWindowForGcnExport() {

    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: "Export Duplicate NDC List",
        bodyMessage: "Are you sure you want to export this drug list?",
        bodyMessage2: "",
        cancelBtnText: "Cancel",
        confirmBtnText: "Export",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        if (this.dataSource.data.length > 0) {
          this.customExcelFileDownload();
        }
      } else {
        console.log("not export", result);
      }
    });
  }
 // redirect() {
   // this.dialogRefImportWizardComponent.close({ event: "close", data: false });
    //this.route.navigate(['./im-tool']);
  //}


  allDrugUnSelect() {
    this.buttonSelected(true,false, false, false)
    this.selectedGcnDrugList = [];
    for (let i = 0; i < this.dataSource.data.length; i++) {
      this.dataSource.data[i].isChecked = false;
    }
  }
  highestUsageDrugSelect() {
    this.buttonSelected(false,false, false, true)
    this.selectedGcnDrugList = [];
    for (let i = 0; i < this.dataSource.data.length; i++) {
      this.dataSource.data[i].isChecked = false;
    }

    let data = this.dataSource.data;
    data = Object.values(data.reduce((x, y) => Object.assign(x, { [y.gcnNumber]: y }), {}))
    let size = data.length;
    for (let k = 0; k < size; k++) {
      let temp;
      for (let j = 0; j < this.dataSource.data.length; j++) {
        if (data[k].gcnNumber === this.dataSource.data[j].gcnNumber) {
          if (temp === undefined || temp === null || this.dataSource.data[j].unitOfUsage > temp.unitOfUsage) {
            temp = this.dataSource.data[j];
          }
        }
      }
      if (temp !== undefined && temp !== null) {
        this.drugCellRowChecked(temp, true)
      }
    }
  }
  lowestUsageDrugSelect() {
    this.buttonSelected(false,false, true, false)
    this.selectedGcnDrugList = [];
    for (let i = 0; i < this.dataSource.data.length; i++) {
      this.dataSource.data[i].isChecked = false;
    }
    let data = this.dataSource.data;
    data = Object.values(data.reduce((x, y) => Object.assign(x, { [y.gcnNumber]: y }), {}))
    let size = data.length;
    for (let k = 0; k < size; k++) {
      let temp;
      for (let j = 0; j < this.dataSource.data.length; j++) {
        if (data[k].gcnNumber === this.dataSource.data[j].gcnNumber) {
          if (temp === undefined || temp === null || this.dataSource.data[j].unitOfUsage < temp.unitOfUsage) {
            temp = this.dataSource.data[j];
          }
        }
      }
      if (temp !== undefined && temp !== null) {
        this.drugCellRowChecked(temp, true)
      }
    }
  }
  largestBottleSize() {
    this.buttonSelected(false,true, false, false)
    this.selectedGcnDrugList = [];
    for (let i = 0; i < this.dataSource.data.length; i++) {
      this.dataSource.data[i].isChecked = false;
    }
    let data = this.dataSource.data;
    data = Object.values(data.reduce((x, y) => Object.assign(x, { [y.gcnNumber]: y }), {}))
    let size = data.length;
    for (let k = 0; k < size; k++) {
      let temp;
      for (let j = 0; j < this.dataSource.data.length; j++) {
        if (data[k].gcnNumber === this.dataSource.data[j].gcnNumber) {
          if (temp === undefined || temp === null || this.dataSource.data[j].packageSize > temp.packageSize) {
            temp = this.dataSource.data[j];
          }
        }
      }
      if (temp !== undefined && temp !== null) {
        this.drugCellRowChecked(temp, true)
      }
    }
  }
  buttonSelected(isUnselectAll, largeButtole, isLowestUsageDrugSelect, isHighestUsageDrugSelect){
    this.isButtonSelectLargeBottle = largeButtole;
    this.isLowestUsageDrugSelect = isLowestUsageDrugSelect;
    this.isHighestUsageDrugSelect = isHighestUsageDrugSelect;
    this.isUnselectAll = isUnselectAll
  }

  drugCellRowChecked(row: any, isChecked: boolean) {
    if (isChecked) {
      this.selectedGcnDrugList.push({
        sl: row.sl,
        ndc: row.ndc,
        drugName: row.drugName,
        customerDrugName: row.customerDrugName,
        strength: row.strength,
        manufacturer: row.manufacturer,
        isChecked: row.isChecked,
        gcnNumber: row.gcnNumber,
        unitOfUsage: row.unitOfUsage,
        backgroundColor: row.background_color,
        rxQty: row.rxQty,
        packageSize: row.packageSize
      });
      let index = this.dataSource.data.findIndex(
        (x) => x.gcnNumber === row.gcnNumber && x.sl === row.sl
      );

      this.dataSource.data[index].isChecked = true;

      //  }
    } else {
      let index = this.selectedGcnDrugList.findIndex(
        (x) => x.gcnNumber == row.gcnNumber && x.sl == row.sl
      );
      if (index >= 0) {
        this.selectedGcnDrugList.splice(index, 1);
      }

    }
  }
  isAlreadyAddedThisGcnDrug(row): boolean {
    let output = false;
    for (let i = 0; i < this.selectedGcnDrugList.length; i++) {
      if (this.selectedGcnDrugList[i].gcnNumber === row.gcnNumber) {
        output = true;
        break;
      }
    }
    return output;
  }

  redirectDrugList(deviceId: number) {
    this.closeWizard.emit(true);
    if (deviceId === 3) {
      this.route.navigate(["/im-tool/atp-export", this.customerId]);
    }
    else if (deviceId === 4) {
      this.route.navigate(["/im-tool/synmed-export", this.customerId]);
    }
    else if(deviceId === 5){
      this.route.navigate(["/im-tool/mini-export", this.customerId]);
    }
    else if(deviceId === 6){
      this.route.navigate(["/im-tool/atp-caps-export", this.customerId]);
    }
    else if(deviceId === 2){

    }
    else {
      this.route.navigate(["/im-tool/export", this.customerId]);
    }

  }
  saveGcnDrugs(isSelectAll: boolean) {
    const GCNDRUG_KEY= 'Gcndrugkey'
    this.ngxLoader.start(GCNDRUG_KEY);
    this.saveGcnDrugListModel = [];
    this.dataSource.data.forEach(element => this.saveGcnDrugListModel.push({ ndc: element.ndc, genericSequenceNumber: element.gcnNumber, usage: element.unitOfUsage, checked: isSelectAll === true ? true : element.isChecked }));
    this.gcnDrugdModel = {
      deviceId: this.deviceId,
      customerId: this.customerId,
      gcnDrug: this.saveGcnDrugListModel
    }
    this.imtoolService.gcnDrugAdd(this.gcnDrugdModel).subscribe((result) => {

      if (result.statusCode === 200) {
        this.toastService.openToast(result.message, constants.ToastPanelType.done, 2);
        this.dataSource.data = [];
        this.selectedGcnDrugList = [];
        this.saveGcnDrugListModel = [];
        this.gcnDrugList = [];
        this.gcnDrugdModel = null;
        this.ngxLoader.stop(GCNDRUG_KEY);
        if (this.deviceId === 3 || this.deviceId === 4 || this.deviceId === 1 || this.deviceId === 5 || this.deviceId === 2 || this.deviceId === 6) {
          this.hideSide.emit(4);
        }
        else {
          this.redirectDrugList(this.deviceId)
        }

      }
      else {
        this.ngxLoader.stop(GCNDRUG_KEY)
        this.toastService.openToast(result.message, constants.ToastPanelType.error, 2);
        this.hideSide.emit(3);
      }

    }, (error: HttpErrorResponse) => {

      this.ngxLoader.stop(GCNDRUG_KEY);
      console.log(error);
      this.toastService.openToast(
        error.error.message ?? error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

  isOpenAlertWizard() {
    if (this.selectedGcnDrugList.length > 0 || this.dataSource.data.length === 0) {
      this.saveGcnDrugs(false)
    }
    else {
      this.openAlertWizardForDuplicateNDC();
    }
  }  

  openAlertWizardForDuplicateNDC() {
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: "Adjust Duplicate NDC List",
        bodyMessage: "No drugs were selected, do you want to keep all these drugs or exclude them?",
        bodyMessage2: "",
        cancelBtnText: "Exclude All Drugs ",
        confirmBtnText: "Keep All Drugs",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data == true) {
        this.saveGcnDrugs(true)
      } else {
        this.saveGcnDrugs(false)
      }
    });
  }

  getGcnDrugList() {
    const GCNDRUGLIST_KEY = 'Gcndruglistkey'
    this.ngxLoader.start(GCNDRUGLIST_KEY);
    this.imtoolService.getGcnDrugs(this.customerId).subscribe((response) => {
      let result = response.data
      let sl = 1;
      this.gcnDrugList = [];
      result?.forEach(element => {
        this.gcnDrugList.push({
          backgroundColor: element.backgroundColor,
          ndc: element.ndc,
          manufacturer: element.manufacturer,
          gcnNumber: element.genericSequenceNumber,
          isChecked: false,
          drugName: element.drugName,
          customerDrugName: element.customerDrugName,
          strength: element.strength,
          unitOfUsage: element.usage,
          sl: sl++,
          rxQty: element.rxQty,
          packageSize: element.packageSize

        })
      });

      this.gcnNumberList = Array.from(this.gcnDrugList.reduce((m, t) => m.set(t.gcnNumber, t.gcnNumber), new Map()).values());


      for (let i = 0; i < this.gcnNumberList.length; i++) {

        let background_color = this.random_bg_color();
        for (let j = 0; j < this.gcnDrugList.length; j++) {
          if (Number(this.gcnNumberList[i]) === Number(this.gcnDrugList[j].gcnNumber)) {
            this.gcnDrugList[j].backgroundColor = background_color;
          }
        }
      }
      this.dataSource.data = this.gcnDrugList;
      this.ngxLoader.stop(GCNDRUGLIST_KEY);
    }, (error: HttpErrorResponse) => {
      this.ngxLoader.stop(GCNDRUGLIST_KEY);
      console.log(error);
      this.toastService.openToast(
        error.error.message ?? error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

  getGcnDrugListForCaps() {
    const GCNDRUGLIST_KEY = 'Gcndruglistkey'
    this.ngxLoader.start(GCNDRUGLIST_KEY);
    this.imtoolService.getGcnDrugsForCaps(this.customerId).subscribe((response) => {
      let result = response.data
      let sl = 1;
      this.gcnDrugList = [];
      result?.forEach(element => {
        this.gcnDrugList.push({
          backgroundColor: element.backgroundColor,
          ndc: element.ndc,
          manufacturer: element.manufacturer,
          gcnNumber: element.genericSequenceNumber,
          isChecked: false,
          drugName: element.drugName,
          customerDrugName: element.customerDrugName,
          strength: element.strength,
          unitOfUsage: element.usage,
          sl: sl++,
          rxQty: element.rxQty,
          packageSize: element.packageSize

        })
      });

      this.gcnNumberList = Array.from(this.gcnDrugList.reduce((m, t) => m.set(t.gcnNumber, t.gcnNumber), new Map()).values());


      for (let i = 0; i < this.gcnNumberList.length; i++) {

        let background_color = this.random_bg_color();
        for (let j = 0; j < this.gcnDrugList.length; j++) {
          if (Number(this.gcnNumberList[i]) === Number(this.gcnDrugList[j].gcnNumber)) {
            this.gcnDrugList[j].backgroundColor = background_color;
          }
        }
      }
      this.dataSource.data = this.gcnDrugList;
      this.ngxLoader.stop(GCNDRUGLIST_KEY);
    }, (error: HttpErrorResponse) => {
      this.ngxLoader.stop(GCNDRUGLIST_KEY);
      console.log(error);
      this.toastService.openToast(
        error.error.message ?? error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

}